import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
export const getDefects = ({ kulModelKodu, garantiTipi }) => axios.get(`/GetSiriusDefects/${kulModelKodu}/${garantiTipi}`);


export const getMaterials = ({
  kulModelKodu,
  garantiTipi,
  hizmetKodu,
  uyil,
  udonem,
  WorkOrderId
}) => {
  const SessionUser = getUser();
  return axios.get(
    `/GetSiriusMaterials/${kulModelKodu}/${garantiTipi}/${hizmetKodu}/${uyil}/${udonem}/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}/${WorkOrderId}`
  );
};




export const getHistoricalMaterials = ({
  kulModelKodu, garantiTipi, hizmetKodu, uyil, udonem
}) => axios.get(`/GetArtemisTarihselAgac/${kulModelKodu}/${garantiTipi}/${hizmetKodu}/${uyil}/${udonem}`);


export const getLabours = ({ kulModelKodu, garantiTipi, hizmetKodu,WorkOrderId }) => {
  const SessionUser = getUser();
  return axios.get(
    `/GetSiriusLabours/${kulModelKodu}/${garantiTipi}/${hizmetKodu}/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}/${WorkOrderId}`
  );
};
